<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
            <div class="code">{{sum_revenue}} <span style="font-size: 20px"> ￥ </span></div>
            <div class="top-text">{{begin_date}}-{{end_date}} </div>
        </div>

        <div class="main">
            <div class="main-option">
                <div class="main-option-item" :class="{ action: action.all}" @click="optionConfirm(0)">全部收益</div>
                <div class="main-option-item" :class="{ action: action.exc}" @click="optionConfirm(2)">交换卡</div>
                <div class="main-option-item" :class="{ action: action.chat}" @click="optionConfirm(4)">畅聊卡</div>
                <div class="main-option-item" :class="{ action: action.vip}" @click="optionConfirm(3)">会员VIP</div>
            </div>
            <div class="main-list" :style="marSty">
                <van-list
                    v-model:loading="loading"
                    :finished="finished"
                    :finished-text="loadingText"
                    @load="onLoad"
                >
                    <div class="main-list-info" v-for="item in list" :key="item.withdraw_id" :title="item" @click="goTotals(item.withdraw_id)">
                        <div class="main-list-info-name">
                            {{item.app_nickname}}
                        </div>

                        <div class="main-list-info-text">
                            <span>{{item.revenue_title}}</span>
                        </div>
                        <div class="main-list-info-time">
                            {{item.create_time}}
                        </div>
                    </div>
                </van-list>

            </div>

        </div>
        <ReferralFooter index="2"/>

    </div>

</template>

<script>

import {showFailToast} from "vant";
import ReferralFooter  from "@/components/referralFooter.vue";
import ayzAjax from "@/plugins/axios";

export default {
    name: "ReloadView",
    components: {
        ReferralFooter
    },
    data: function () {
        return {
            sum_revenue:0.00,
            list:[],
            loading:false,
            finished:false,
            page:1,
            jwtInfo:null,
            userInfo:null,
            begin_date:'',
            end_date:'',
            withdraw_id:0,
            loadingText: '暂无数据',
            option:0,
            action:{
                all:true,
                exc:false,
                chat:false,
                vip:false,
            },
            marSty:{}
        }
    },
    created() {
        this.jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.account = this.userInfo.mobile_hide;
        this.withdraw_id = this.$route.query.id;
    },
    methods: {
        optionConfirm(type){
            if (type === this.option){
                return false;
            }
            this.option = type;
            for (let actionKey in this.action) {
                this.action[actionKey] = false;
            }
            if (this.option === 0){
                this.action.all = true;
            }else if (this.option === 2){
                this.action.exc = true;
            }else if (this.option === 3){
                this.action.vip = true;
            }else if (this.option === 4){
                this.action.chat = true;
            }

            this.list = [];
            this.page = 1;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad(){
            let url = '/referral/withdraw_detail?page=' + this.page + '&withdraw_id=' + this.withdraw_id + '&revenue_type=' + + this.option;
            try {
                ayzAjax.get(url,{
                    headers: {
                        'Authorization': 'Bearer ' + this.jwtInfo.access_token,
                    }
                }).then((info) => {
                    if (info.data.code === 4){
                        return this.$router.push({ path: '/referral/login'});
                    }
                    if(info.data.code !== 200){
                        this.$router.push({ path: '/referral/index'});
                        return showFailToast(info.data.msg)
                    }

                    this.sum_revenue = info.data.data.withdraw_log.sum_revenue
                    this.begin_date = info.data.data.withdraw_log.begin_date;
                    this.end_date = info.data.data.withdraw_log.end_date;
                    info.data.data.revenues.forEach((item) => {
                        this.list.push(item)
                    });
                    this.loading = false;

                    if (info.data.data.revenues.length < 20) {
                        this.finished = true;
                    }else{
                        this.finished = false;
                        this.page ++
                    }
                    if (this.list.length > 0) {
                        this.loadingText = '到底了'
                    }else{
                      this.marSty = {marginTop: '100px'}
                    }
                })
            }catch (e) {
                console.log(e);
                showFailToast('网络错误,请稍后再试');
            }
        },
    }
}
</script>

<style lang="scss" scoped>

.reload-view {
    background-color: #F6F6F6;
    text-align: left;
    .top-back {
        background-image: url('~@/assets/referral-back2.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 120px;
        color: #FFFFFF;
        .code {
            padding-top: 30px;
            padding-left: 30px;
            font-weight: 600;
            font-size: 27px;
        }
        .top-text {
            margin-top: 15px;
            margin-left: 30px;
            margin-right: 25px;
            font-weight: 300;
            font-size: 14px;
        }
    }
    .main {
        min-height: 500px;
        margin: 12px;
        background: #FFFFFF;
        border-radius: 17px 17px 17px 17px;

        .main-option{
            padding-top: 25px;
            margin-left: 15px;
            font-weight: 400;
            font-size: 13px;
            color: #C7C7C7;
            display: flex;
            margin-bottom: 15px;
            .main-option-item{
                margin-right: 20px;
            }
        }
        .main-list-info{
            margin-top: 5px;
            height: 40px;
            //background: #F94B54;
            line-height: 40px;
            padding-left: 15px;
            font-size: 12px;
            .main-list-info-name{
                float: left;
                width: 100px;
                color: #555555;
            }

            .main-list-info-text{
                width: 80px;
                float: left;
                color: #555555;
            }
            .main-list-info-time{
                float: left;
                color: #555555;
            }
        }
    }
}
.action{
    font-weight: bold;
    color: #222222;
}
</style>
